export default __webpack_public_path__ + "static/meditechnology-79c2dc9f07ffe1842167002a8618d6c2.png";